var exports = {
  "k": "x112a1f60--dbb3d3--container",
};

module.exports = exports;
